import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { allowedAdminEmails } from "../config/adminUsers";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      const authorized = currentUser?.email && allowedAdminEmails.includes(currentUser.email);
      setIsAuthorized(authorized);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#060607] text-white">
        <span>جاري التحقق من الحساب...</span>
      </div>
    );
  }

  return isAuthorized ? children : <Navigate to="/login" replace />;
}
